import * as FIELD_NAME from 'constant/form-item-names'
import * as FIELD_LABEL from 'constant/form-labels'
import * as RULES from 'constant/form-rules'
import PropTypes from 'prop-types'
import React from 'react'
import { Form, Upload, Button } from 'antd'
import { PaperClipOutlined, UploadOutlined } from '@ant-design/icons'

const AttachmentUpload = ({ fileName, allowUpload }) => {
  const normFile = (event) => event?.file

  return (
    <>
      <Form.Item
        getValueFromEvent={normFile}
        label={allowUpload && FIELD_LABEL.ATTACHMENT}
        name={FIELD_NAME.ATTACHMENT_FILE}
        rules={allowUpload ? [RULES.REQUIRED] : []}
        valuePropName='file'
      >
        <Upload beforeUpload={() => false}>
          <Button
            disabled={!allowUpload}
            icon={<UploadOutlined />}
          >Choose File</Button>
        </Upload>
      </Form.Item>
      {fileName && <p><PaperClipOutlined /> {fileName}</p>}
    </>
  )
}

AttachmentUpload.propTypes = {
  allowUpload: PropTypes.bool,
  fileName: PropTypes.string
}

export default AttachmentUpload
